import { BASE_API } from "../Config/Config";

export const fetchorgchartapi = async (type) => {
    try {
        const formdata = new FormData();

        formdata.append("type", type);
        const response = await fetch(
            `${BASE_API}/apis/orgchartShow.php`,
            {
                method: "POST",
                body: formdata,
            }
        );

        const result = await response.json();

        if (
            result.status === "success" &&
            Array.isArray(result.data)
        ) {
            return result.data;
        } else {
            return [];
        }
    } catch (err) {
        console.error("Fetch Error:", err);
        return [];
    }
};